import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Light Background", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "h1" }, "Heading 1", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "h2" }, "Heading 2", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "h3" }, "Heading 3", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "h4" }, "Heading 4", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Heading 5", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Heading 6", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "sub-head" }, "Sub-head", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "large" }, "Paragraph Large", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "small" }, "Paragraph Small", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Link", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "warning" }, "Warning", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Dark Background", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dark-background" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "on-dark" }, "Paragraph on Dark Background"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "on-dark"
  }, "Link on Dark Background"),
  /*#__PURE__*/_createElementVNode("p", { class: "warning on-dark" }, "Warning on Dark Background")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "style-guide--typography" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _hoisted_13,
          _hoisted_14
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}